<template>
  <div class="fd-palette">
    <div class="fd-section-title">
      <feather-icon
        icon="DatabaseIcon"
        size="14"
        class="mr-50"
      />
      Поля куба
    </div>

    <input
      v-model="search"
      class="fd-palette-search"
      placeholder="Поиск поля..."
    >

    <div
      v-if="loading"
      class="fd-palette-loading"
    >
      <b-spinner
        small
        variant="primary"
      />
      <span
        class="ml-50 text-muted"
        style="font-size:11px"
      >Загрузка...</span>
    </div>

    <div
      v-else-if="filteredFields.length === 0"
      class="fd-palette-empty"
    >
      <span v-if="search">Ничего не найдено</span>
      <span v-else>Нет полей. Выберите куб в record-уровне.</span>
    </div>

    <div
      v-else
      class="fd-palette-list"
    >
      <div
        v-for="field in filteredFields"
        :key="field.entityId"
        class="fd-palette-field"
        draggable="true"
        @dragstart="onDragStart($event, field)"
      >
        <span
          class="fd-palette-type"
          :class="'fd-dt--' + field.datatype"
        >
          {{ dtIcon(field.datatype) }}
        </span>
        <span
          class="fd-palette-name"
          :title="field.entitySid + ' (ID: ' + field.entityId + ')'"
        >
          {{ field.name }}
        </span>
        <span
          class="fd-palette-add"
          title="Добавить в record-уровень"
          @click.stop="$emit('add-field', field)"
        >
          <feather-icon
            icon="PlusIcon"
            size="12"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'

export default {
  name: 'CbsFormDesignerFieldPalette',
  components: { BSpinner },
  props: {
    fields: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return { search: '' }
  },
  computed: {
    filteredFields() {
      const sorted = [...this.fields].sort((a, b) => a.name.localeCompare(b.name, 'ru'))
      if (!this.search) return sorted
      const q = this.search.toLowerCase()
      return sorted.filter(f => f.name.toLowerCase().includes(q)
        || f.entitySid.toLowerCase().includes(q))
    },
  },
  methods: {
    onDragStart(event, field) {
      event.dataTransfer.setData('application/json', JSON.stringify(field))
      event.dataTransfer.effectAllowed = 'copy'
    },
    dtIcon(dt) {
      const map = {
        id: 'ID',
        string: 'Aa',
        text: 'Txt',
        int: '123',
        double: '1.2',
        bit: '☑',
        ref: '🔗',
        refsid: '🔗',
        datetime: '📅',
        file: '📎',
        json: '{ }',
        money: '💰',
      }
      return map[dt] || dt || '?'
    },
  },
}
</script>

<style scoped>
.fd-palette {
  width: 230px;
  min-width: 230px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 12px;
  background: #fafafa;
  max-height: 600px;
  display: flex;
  flex-direction: column;
}
.fd-palette-search {
  width: 100%;
  padding: 6px 10px;
  font-size: 13px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 8px;
  outline: none;
}
.fd-palette-search:focus {
  border-color: #7367f0;
}
.fd-palette-loading, .fd-palette-empty {
  text-align: center;
  padding: 20px 8px;
  color: #999;
  font-size: 12px;
}
.fd-palette-list {
  display: flex;
  flex-direction: column;
  gap: 1px;
  overflow-y: auto;
  flex: 1;
}
.fd-palette-field {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  border-radius: 4px;
  cursor: grab;
  font-size: 12px;
  transition: background 0.15s;
}
.fd-palette-field:hover {
  background: #e8e5ff;
}
.fd-palette-field:active {
  cursor: grabbing;
}
.fd-palette-type {
  font-size: 9px;
  font-weight: 700;
  min-width: 24px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  flex-shrink: 0;
}
.fd-dt--string, .fd-dt--text { background: #e8f5e9; color: #2e7d32; }
.fd-dt--int, .fd-dt--double, .fd-dt--money { background: #e3f2fd; color: #1565c0; }
.fd-dt--ref, .fd-dt--refsid { background: #fff3e0; color: #e65100; }
.fd-dt--bit { background: #fce4ec; color: #c62828; }
.fd-dt--datetime { background: #f3e5f5; color: #6a1b9a; }
.fd-dt--id { background: #eee; color: #666; }
.fd-dt--json { background: #eceff1; color: #455a64; }
.fd-palette-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fd-palette-add {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: #999;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.15s;
}
.fd-palette-add:hover {
  background: #7367f0;
  color: #fff;
}
</style>
